export const INTEGRATION_CODE_AWS = "AWS";
export const INTEGRATION_CODE_SAP_SUCCESS_FACTOR = "SFS";

export const INTEGRATION_TYPE_BASIC = "BS";
export const INTEGRATION_TYPE_OAUTH = "OA";
export const INTEGRATION_TYPE_API_TOKEN = "AT";
export const INTEGRATION_TYPE_CUSTOM = "CUSTOM";

export const hasConnectionType = (taggedData, typeCode) => {
    return (taggedData || [])?.some(
        (item) => item?.connectionTypeData?.code === typeCode
    );
};

// Add the Integration Code for getting the Warning and Info Icons for the keys in the integration connection page here
export const getKeyForIntegration = (integrationCode) => {
    return (
        integrationCode === INTEGRATION_CODE_SAP_SUCCESS_FACTOR
    );
};